'use client';

import { faCrown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Group, Text } from '@mantine/core';
import { useGlobalModal } from '@modules/global-modals/use-global-modal';

import { buttonTextStyle } from './styles.css';

export function UpgradeButton() {
  const { openModal } = useGlobalModal({
    registeredModals: ['UPGRADE'],
  });

  const handleUpgrade = () => {
    openModal?.({
      type: 'UPGRADE',
      trackingSource: 'side-navigation',
    });
  };

  return (
    <Box style={{ marginTop: 'auto' }} px="sm" py="sm">
      <Button variant="outline" size="md" fullWidth onClick={handleUpgrade}>
        <Group align="center" justify="center" gap="sm" wrap="nowrap">
          <FontAwesomeIcon icon={faCrown} />
          <Text fw={600} className={buttonTextStyle}>
            Upgrade account
          </Text>
        </Group>
      </Button>
    </Box>
  );
}
